import { useAnalyticsModalContext } from "PFApp/analytics/parts/top_actions_panel/analytics_modal_context_provider";
import { ExportType } from "PFApp/analytics/types/export_analytics";
import { GenerateReportPayload } from "PFCore/services/export_booking/export_booking.types";
import { useCallback } from "react";

import { useTemplatePayloadProvider } from "./use_template_payload_provider";

type UseGenerateRequestProviderReturn = (reportName: string) => GenerateReportPayload;

export const useGeneratePayloadProvider = (): UseGenerateRequestProviderReturn => {
  const {
    state: {
      data: { exportType, schedule, selectedTemplate }
    }
  } = useAnalyticsModalContext();
  const provideTemplatePayload = useTemplatePayloadProvider();

  return useCallback(
    (name) => {
      const basicRequestPart: Pick<GenerateReportPayload, "name" | "schedule"> = {
        name,
        schedule: {
          repeat: schedule.frequency,
          repeatDetails: schedule.value
        }
      };
      if (exportType === ExportType.Template && selectedTemplate) {
        return {
          ...basicRequestPart,
          templateId: selectedTemplate.id
        };
      }
      const template = provideTemplatePayload();
      return {
        ...basicRequestPart,
        template
      };
    },
    [exportType, schedule, selectedTemplate, provideTemplatePayload]
  );
};
